<template>
  <b-modal ref="moveQuestionModal" title="Frage verschieben">
    <b-form-select :options="options" v-model="position">

    </b-form-select>
    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="send">Bestätigen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
  export default {
    name: 'DeleteModal',

    data: function () {
      return {
        id: null,
        position: null,
        length: 0,
        options: []
      }
    },

    methods: {
      show: function (item, length) {
        this.id = item.id
        this.position = item.position
        this.length = length

        for (let i = 1; i <= length; i++) {
          this.options.push(i)
        }

        this.$refs.moveQuestionModal.show()
      },

      hide () {
        this.$refs.moveQuestionModal.hide()
      },

      send () {
        this.axios.put(
          '/questions/' + this.id + '/position',
          JSON.stringify({
            position: this.position
          })
        ).then(this.$emit('reload'))

        this.$refs.moveQuestionModal.hide()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/competitions/admin/MoveQuestionModal.vue